import {
  calculateSectionAccumulatedTime,
  calculateSectionAverageScore,
} from './sectionProgressMetrics';

type SectionDisplayLike = {
  score?: number | null;
  time_accumulator?: number | null;
  completion_date?: string | null;
  progress?: {
    steps?: Array<{
      score?: number | null;
      time_accumulator?: number | null;
      completion_date?: string | null;
      step_type?: string | null;
      isSkippedFilter?: boolean | null;
    }>;
  } | null;
};

export function resolveSectionDisplayScore(
  section: SectionDisplayLike | null | undefined,
): number {
  const steps = section?.progress?.steps;
  if (Array.isArray(steps) && steps.length > 0) {
    return Math.round(calculateSectionAverageScore(steps));
  }

  return section?.score ?? 0;
}

export function resolveSectionDisplayTime(
  section: SectionDisplayLike | null | undefined,
): number {
  const steps = section?.progress?.steps;
  if (Array.isArray(steps) && steps.length > 0) {
    return calculateSectionAccumulatedTime(steps);
  }

  return section?.time_accumulator ?? 0;
}
